import { render, staticRenderFns } from "./EntityContacts.vue?vue&type=template&id=2653475b&scoped=true"
import script from "./EntityContacts.vue?vue&type=script&lang=js"
export * from "./EntityContacts.vue?vue&type=script&lang=js"
import style0 from "./EntityContacts.vue?vue&type=style&index=0&id=2653475b&prod&lang=scss"
import style1 from "./EntityContacts.vue?vue&type=style&index=1&id=2653475b&prod&lang=scss&scoped=true"
import style2 from "./EntityContacts.vue?vue&type=style&index=2&id=2653475b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2653475b",
  null
  
)

export default component.exports